<script lang="ts">
  import { Button } from "$lib/components/ui/button"
  import { MoveRight } from "lucide-svelte"
  import { getRequirement } from "../../utils"
  import { getContext } from "svelte"
  import { t, getCurrentLanguage } from "$lib/utils/i18n"

  interface Props {
    action: any
    processAction: (action: any) => void
  }

  let { action, processAction }: Props = $props()

  const language = getCurrentLanguage()
  const entries = getRequirement(action, "Entries") || 0

  // If inAppBrowser is true, we need to open the link
  // in the app to trigger Instagram bottom navigation bar
  const inAppBrowser = getContext("inAppBrowser")

  let description = $derived(
    (action.selectedAction || action)?.requirements.find(
      (r) => r.name === "Instructions",
    )?.value,
  )

  let buttonText = $derived(
    (action.selectedAction || action)?.requirements.find(
      (r) => r.name === "Button Text",
    )?.value,
  )

  let entryPluralized = $derived(
    t("widget_action_entries", {
      values: { count: Number(entries) },
    }),
  )

  function getFacebookUrl(action) {
    let url =
      getRequirement(action, "Username") ||
      getRequirement(action, "URL") ||
      getRequirement(action, "Facebook Post Url") ||
      getRequirement(action, "Facebook Url")

    // Add Facebook domain if not already included
    if (url && !url.includes("facebook.com")) {
      url = `https://www.facebook.com/${url}`
    }
    return url
  }
</script>

<div class="bg-white rounded-lg p-4 shadow-lg">
  <div class="mb-4">
    {#if description}
      <div class="description-content text-black mb-10">
        {@html description}
      </div>
    {:else}
      <h4 class="text-sm font-medium mb-2">
        {t("widget_action_worth", { count: entries, entries: entryPluralized })}
      </h4>
    {/if}
  </div>

  <a
    href={getFacebookUrl(action)}
    target={inAppBrowser ? "_self" : "_blank"}
    class="block"
    onclick={() => processAction(action)}
  >
    <Button
      variant="default"
      class="w-full bg-black text-white hover:bg-gray-800 flex items-center justify-center gap-2"
    >
      {#if (action.selectedAction || action.actions)?.name === "Custom Action"}
        {buttonText}
      {:else}
        {(action.selectedAction || action.actions)?.translations?.[language]
          ?.name}
      {/if}
      <MoveRight />
    </Button>
  </a>
</div>
